import { Home, ShieldCheck, Wind, FileCheck, Thermometer, Landmark } from "lucide-react";

const items = [
  { icon: Home, text: "PRE-PURCHASE INSPECTIONS" },
  { icon: FileCheck, text: "FL 4-POINT INSPECTION CERTIFIED" },
  { icon: Wind, text: "WIND MITIGATION SAVINGS SPECIALIST" },
  { icon: ShieldCheck, text: "FL LICENSE #HI19148" },
  { icon: Thermometer, text: "THERMAL IMAGING MOISTURE DETECTION" },
  { icon: Landmark, text: "CITIZENS INSURANCE READY REPORTS" },
];

const Row = () => (
  <div className="flex items-center shrink-0">
    {items.map((it) => (
      <div key={it.text} className="flex items-center gap-4 px-10">
        <it.icon size={16} className="text-sun shrink-0" />
        <span className="font-mono text-xs tracking-[0.3em] text-sand/45 whitespace-nowrap">{it.text}</span>
      </div>
    ))}
  </div>
);

export const Marquee = () => (
  <div data-testid="editorial-marquee" className="bg-deep border-y border-sand/10 py-5 overflow-hidden relative">
    <div className="marquee-track">
      <Row />
      <Row />
    </div>
  </div>
);
